import type { FC } from "react";

import type { IButton } from "@/design-system/button";
import ChevronRight from "@/design-system/icons/chevron-right";
import TelemetryButton from "@/design-system/telemetry-button";
import type { TelemetryClickFromType } from "@Components/Modules/Helpers";
import * as stylex from "@stylexjs/stylex";

export type IBrandPageLink = Omit<Extract<IButton, { as: "a" }>, "as"> & {
    brandId: string;
    origin: TelemetryClickFromType;
    text: string;
};

export const BrandPageLink: FC<IBrandPageLink> = (props) => {
    const { styleX, text, origin, brandId, ...rest } = props;

    return (
        <TelemetryButton
            {...rest}
            as="a"
            variant="transparent"
            size="None"
            eventName="Brand-brandClick"
            itemId={brandId}
            origin={origin}
            styleX={[styles.button, styleX]}
        >
            {text}
            <span {...stylex.props(styles.icon)}>
                <ChevronRight />
            </span>
        </TelemetryButton>
    );
};

const styles = stylex.create({
    button: {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        gap: 0,
    },
    icon: {
        width: "1.5rem",
        height: "1.5rem",
    },
});
